// author :fandongxiao
import * as http from "./api"

//通过fileId 返回文件地址
export function getFileUrl (fileId, isLogin) { // todo 登录状态需去掉publicrs，但是不带publicrs路径还不通
  isLogin = isLogin === undefined ? true : isLogin // 不传默认是登录态，不带publicrs
  isLogin = false //  暂定方案 获取图片不支持不带publicrs
  return `${ http.baseURL }/bds${ !isLogin ? '/publicrs' : '' }/image/${ fileId }`
}

//raw，文件二进制内容， 上传到服务器，并返回fileId
export function uploadFile (raw, isLogin) {
  return new Promise((resolve, reject) => {
    isLogin = isLogin === undefined ? true : isLogin // 不传默认是不带publicrs
    // isLogin = false
    http.UPLOAD(`/bds${ !isLogin ? '/publicrs' : '' }/image/upload`, raw).then(res => {
      if (res.ret === 0) {
        resolve(res)
      } else {
        reject(res)
      }
    }).catch(err => {
      reject(err)
    })
  });
}

export const getImageUrl = getFileUrl  //小名
export const uploadImage = uploadFile   //小名

export function exporExcel(data, name) {
  console.log("exporExcel--",data);
  data = data.data;
  if (!data) {
    //如果没有data数据就不进行操作
    this.$message.warning("请选择数据");
    return;
  }
  let fileName = name;
  let blob = new Blob([data], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  }); //转换成二进制对象
  if ("download" in document.createElement("a")) {
    // 不是IE浏览器
    console.log("download");
    let url = window.URL.createObjectURL(blob); //二进制对象转换成url地址
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  } else {
    window.navigator.msSaveBlob(blob, fileName);
  }
}